/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IDobbiesNewStoreLocatorData } from './dobbies-new-store-locator.data';
import { IDobbiesNewStoreLocatorProps } from './dobbies-new-store-locator.props.autogenerated';
import { IDobbiesStoresByRegions } from './dobbies-new-store-locator.view';
import { createStoresDataArray } from './utils/store-utils';

export interface IDobbiesNewStoreLocatorViewProps extends IDobbiesNewStoreLocatorProps<IDobbiesNewStoreLocatorData> {
    storesByRegions: IDobbiesStoresByRegions[];
    noStoreAlphabetsState: string[];
}

export interface IDobbiesNewStore {
    name?: string;
    pageUrl?: string;
}

export interface IDobbiesNewStoreLocatorSortedData {
    alphabet: string;
    stores: IDobbiesNewStore[];
}

/**
 *
 * DobbiesNewStoreLocator component
 * @extends {React.PureComponent<IDobbiesNewStoreLocatorProps<IDobbiesNewStoreLocatorData>>}
 */

export interface IDobbiesNewStoreLocatorState {
    storesByRegions: IDobbiesStoresByRegions[];
    noStoreAlphabetsState: string[];
    calledOnce: boolean;
}
class DobbiesNewStoreLocator extends React.PureComponent<
    IDobbiesNewStoreLocatorProps<IDobbiesNewStoreLocatorData>,
    IDobbiesNewStoreLocatorState
> {
    constructor(props: IDobbiesNewStoreLocatorProps<IDobbiesNewStoreLocatorData>) {
        super(props);
        this.state = { storesByRegions: [], noStoreAlphabetsState: [], calledOnce: false };
    }

    private alphabetsList = [
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z'
    ];

    private updateRegions = (): IDobbiesStoresByRegions[] => {
        const allStoresByRegions: IDobbiesStoresByRegions[] = [];
        const configRegions = this.props.config.storesByRegionsData || [];
        const nostoresAlphabets: string[] = [];
        if (configRegions && configRegions.length) {
            for (const cr of configRegions) {
                if (cr.regionName && cr.storesInfo) {
                    const stores = createStoresDataArray(cr.regionName, cr.storesInfo);
                    allStoresByRegions.push({ regionName: cr.regionName, stores: stores });
                }
            }
        }
        for (const alpha of this.alphabetsList) {
            let hasStores = false;
            for (const asbr of allStoresByRegions) {
                if (hasStores) {
                    break;
                }
                for (const st of asbr.stores) {
                    if (hasStores) {
                        break;
                    }
                    for (const stCol of st) {
                        if (stCol.name?.toLowerCase().startsWith(alpha.toLowerCase())) {
                            hasStores = true;
                            break;
                        }
                    }
                }
            }
            if (!hasStores) {
                nostoresAlphabets.push(alpha);
            }
        }
        this.setState({ storesByRegions: allStoresByRegions, noStoreAlphabetsState: nostoresAlphabets, calledOnce: true });
        return allStoresByRegions;
        // setStoresByRegions(allStoresByRegions);
        // setNoStoreAlphabets(nostoresAlphabets);
    };

    public render(): JSX.Element | null {
        let storesByRegionsData;
        if (this.state.storesByRegions.length <= 0 && !this.state.calledOnce) {
            storesByRegionsData = this.updateRegions();
        }
        const newStoreLocatorProps: IDobbiesNewStoreLocatorViewProps = {
            ...this.props,
            storesByRegions: this.state.storesByRegions.length ? this.state.storesByRegions : storesByRegionsData || [],
            noStoreAlphabetsState: this.state.noStoreAlphabetsState
        };
        return this.props.renderView(newStoreLocatorProps);
    }
}

export default DobbiesNewStoreLocator;
